import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { route } from '../../../routes';
import useLanguageSwitcher from '@careers-wales/react-components/dist/hooks/useLanguageSwitcher';
import { useTranslation } from 'react-i18next';
import ResultsView from "../views/ResultsView";
// Navigate.

import {useAuthentication, SessionStorage, useErrors, isJsonValid, Response, shuffleArray} from "@careers-wales/react-components";

function ResultsController(props) {
    // Hooks.
    const { setLanguageSwitcherHref } = useLanguageSwitcher();
    const { i18n } = useTranslation();
    const navigate = useNavigate();

    // Set language switcher url.
    useEffect(() => {
        setLanguageSwitcherHref(route('results', null, i18n.language === 'en' ? 'cy' : 'en'));
    }, []);

    return (
        <>
            {props.results === null && navigate(route('landing'))}
           <Response hasLoaded={props.results !== null} errors={[]}>

                <ResultsView {...props} />

            </Response>
        </>
    );
}

export default ResultsController;
